export default __webpack_public_path__ + "static/media/ServoCMP.1f56b4f1.webp";